import { thumbHashToDataURL } from 'thumbhash'

export function thumbhashToBase64(file) {
	const { hash } = file
	if (!hash) return

	try {
		const binary = new Uint8Array(hash.match(/.{1,2}/g).map(x => parseInt(x, 16)))
		return thumbHashToDataURL(binary)
	}
	catch (err) {
		return
	}
}